var _rect, _rect2, _rect3, _rect4, _rect5, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCartFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 253,
    viewBox: "0 0 230 253",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 76.8457,
    width: 57,
    height: 57,
    transform: "rotate(-15.0962 64 76.8457)",
    fill: "url(#pattern0)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 35.1904,
    width: 57,
    height: 57,
    transform: "rotate(-38.1243 35 35.1904)",
    fill: "url(#pattern1)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 105.877,
    y: 23.001,
    width: 57,
    height: 57,
    transform: "rotate(7.94315 105.877 23.001)",
    fill: "url(#pattern2)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 149.131,
    y: 62.001,
    width: 57,
    height: 57,
    transform: "rotate(15.3936 149.131 62.001)",
    fill: "url(#pattern3)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 35.8057,
    width: 57,
    height: 57,
    transform: "rotate(-31.5262 150 35.8057)",
    fill: "url(#pattern4)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M206.182 171.91V194.819H57.2727V183.365H45.8182V137.546H34.3636V103.183H22.9091V45.9101H0V23.001H45.8182V57.3646H229.091V103.183H217.636V137.546H206.182V149.001H68.7273V171.91H206.182ZM45.8182 91.7283H57.2727V126.092H194.727V91.7283H206.182V80.2737H45.8182V91.7283ZM68.7273 206.274H91.6364V217.728H103.091V240.637H91.6364V252.092H68.7273V240.637H57.2727V217.728H68.7273V206.274ZM160.364 206.274H183.273V217.728H194.727V240.637H183.273V252.092H160.364V240.637H148.909V217.728H160.364V206.274Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_107_9",
    transform: "scale(0.00390625)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_107_9",
    transform: "scale(0.00390625)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_107_9",
    transform: "scale(0.00390625)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern3",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_107_9",
    transform: "scale(0.00390625)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern4",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_107_9",
    transform: "scale(0.00390625)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_107_9",
    width: 256,
    height: 256,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEACAYAAABccqhmAAAAAXNSR0IArs4c6QAABBJJREFUeJzt3bGNKjEUQNGdry2ELiahD6rYiDoohD42oYvphN8DD8mL7jm5GYPgyokfX18AAAAAAAAAAAAAAAAAAADAX7NNX+D5fD7fsZFVtm0bfwas4/s382/lw4G1BADCBADCBADCBADCBADCBADCBADCBADCBADCBADCBADCBADCBADCBADCvqf3qU+n05u28pp930frP/0+ed3lchmtfzweb9rJa6bfv+k8AScACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACNum95E//T42rHQcx2i9eQDAywQAwgQAwgQAwgQAwgQAwgQAwgQAwgQAwgQAwgQAwgQAwgQAwgQAwgQAwkZ3ib++5v9vfjqdpltY6nq9Ln3+7XZb+vzVVn/+Pz8/o/XT+/xTTgAQJgAQJgAQJgAQJgAQJgAQJgAQJgAQJgAQJgAQJgAQJgAQJgAQJgAQJgAQtnwewOVyGT3/8XiM1k/t+z5afz6f37STNabzCFbf5//9/R2tv9/vo/XmAQDLCACECQCECQCECQCECQCECQCECQCECQCECQCECQCECQCECQCECQCECQCEmQfw4Y7jGK0/nU5v2ccqq9//9PnmAQDLCACECQCECQCECQCECQCECQCECQCECQCECQCECQCECQCECQCECQCECQCEfbvPD6+bzhOY/v6m8wScACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBsMw+Ala7X6+otjNxut6XPP45jtN4JAMIEAMIEAMIEAMIEAMIEAMIEAMIEAMIEAMIEAMIEAMIEAMIEAMIEAMIEAMK+V2+Atul9+n3fR+vr8yicACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACDMPIAPd71eR+tX/7/91Pl8Hq03DwDIEgAIEwAIEwAIEwAIEwAIEwAIEwAIEwAIEwAIEwAIEwAIEwAIEwAIEwAI257P53PyApfL5V17eUn9PvfUdJ5A3ep5CsdxjNY7AUCYAECYAECYAECYAECYAECYAECYAECYAECYAECYAECYAECYAECYAECYAEDYNn0B8wTgdfu+j9bf7/fReicACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBMACBvPA5j69HkCq5lnsNbq+/zbto1+w04AECYAECYAECYAECYAECYAECYAECYAECYAECYAECYAECYAECYAECYAECYAELZ8HsDUdJ4ArDS9zz/lBABhAgBhAgBhAgBhAgBhAgBhAgBhAgBhAgBhAgBhAgBhAgBhAgBhAgBhAgAAAAAAAAAAAAAAAAAAAAAAf8h/qsyWghtbZcgAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartFull);
export default __webpack_public_path__ + "static/media/cartFull.445f7dfcb9cefb2b53910702a06e5e26.svg";
export { ForwardRef as ReactComponent };